/*
 * @Descripttion:
 * @Author: huxianglong
 * @Date: 2023-07-03 10:59:04
 * @LastEditors: sueRimn
 * @LastEditTime: 2024-01-26 11:16:15
 */
import type { ILoginData } from "@/api/types";
import { BASE_URL, TIME_OUT } from "./config";
import GSRequest from "./request";
import router from "@/router";
import { ElMessage } from "element-plus";

const errorOutCodes: Array<string> = ["0004", "0005", "0006", "0007", "0024"];

// 根据不同配置创建不同axios实例
const gsRequest = new GSRequest({
  baseURL: BASE_URL,
  timeout: TIME_OUT,
  interceptors: {
    requestSuccessFn(config) {
      // console.log('个别axios instance请求成功拦截', config)
      let session: string | ILoginData | null =
        window.sessionStorage.getItem("login_user_info");
      if (config.headers) {
        config.headers["TO-WHERE"] = `service-lls`;
        // config.headers['TO-WHERE'] = `service-hyc`
      }
      if (session) {
        session = JSON.parse(<string>session) as ILoginData;
        if (config.headers) {
          config.headers["X-Auth-Token"] = `${session.accessToken}`;
        }
      }
      return config;
    },
    requestFailureFn(err) {
      // console.log('service requestFailureFn err ----->', err)
      return err;
    },
    responseSuccessFn(res) {
      // console.log('service responseSuccessFn res ----->', res)
      const { code } = res.data;
      if (code !== "0000") {
        ElMessage.error(res.data?.errorMessage || res.data?.message);
        if (errorOutCodes.includes(code)) {
          toLogin();
        }
      }
      return res.data;
    },
    responseFailureFn(err) {
      console.log("service responseFailureFn err ----->", err);
      // const { code } = err.response
      // switch (code) {
      //   case '0006':
      //     toLogin()
      //     break
      //   default:
      // }
      return err;
    },
  },
});

const toLogin = () => {
  window.sessionStorage.clear();
  router.replace("/guid");
  // window.location.reload()
};

export default gsRequest;
